import { useContext } from 'react';
import { TwoFactorAuthenticationContext } from '../../Authentication/TwoFactorAuthenticationProvider';

export const useTwoFactorAuthenticationModal = () => useContext(TwoFactorAuthenticationContext);
